import { Button, Stack, Tooltip } from "@mui/material";
import { ReactComponent as SuccessIcon } from "images/success.svg";
import { toast } from "react-toastify";
import { toastifyConfig } from "./ReferralForm/ReferralForm.common";

const showSuccessNotification = (copiedText) =>
  toast(
    () => (
      <Stack direction={"row"} gap={1}>
        <SuccessIcon />
        <Stack>
          <div className="text-sm">{copiedText}</div>
        </Stack>
      </Stack>
    ),
    // @ts-ignore
    toastifyConfig
  );

const ClipboardCopyButton = ({
  textToCopy,
  label,
  tooltip = undefined,
  copiedText,
}) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);

      showSuccessNotification(copiedText);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <Tooltip title={tooltip}>
      <Button
        onClick={handleCopy}
        color="primary"
        variant="contained"
        sx={{ padding: "4px 16px", width: "fit-content" }}
      >
        {label}
      </Button>
    </Tooltip>
  );
};

export default ClipboardCopyButton;
